import React from "react";

import ChooseRegisterType from "../../../../../presentation/pages/register-account/choose-rigister-type";

const MakeChooseRegisterType: React.FC = () => <ChooseRegisterType />;

export default MakeChooseRegisterType;
